
import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import Customers from '../views/Customers.vue'
import Projects from '../views/Projects.vue'
import AdminApproval from '../views/AdminApproval.vue'
import UserInfo from '../views/UserInfo.vue'
import Messages from '../views/Messages.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },

  { path: '/', component: Login },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
    meta: { requiresAuth: true }
  },
  {
    path: '/projects',
    name: 'Projects',
    component: Projects,
    meta: { requiresAuth: true }
  },
  {
    path: '/AdminApproval',
    name: 'AdminApproval',
    component: AdminApproval,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/userInfo',
    name: 'UserInfo',
    component: UserInfo,
    meta: { requiresAuth: true }
  },
  {
    path: '/messages',
    name: 'messages',
    component: Messages,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
